"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useBalanceProvider = void 0;
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const selectors_1 = require("../AccountProvider/selectors");
const _reduxjs_1 = require("../../utils/@reduxjs");
const selectors_2 = require("./selectors");
const slice_1 = require("./slice");
const saga_1 = require("./saga");
const useBalanceProvider = () => {
    (0, _reduxjs_1.useInjectReducer)({ key: slice_1.sliceKey, reducer: slice_1.reducer });
    (0, _reduxjs_1.useInjectSaga)({ key: slice_1.sliceKey, saga: saga_1.BalanceProviderSaga });
    const dispatch = (0, react_redux_1.useDispatch)();
    const user = (0, react_redux_1.useSelector)(selectors_1.selectAccountUser);
    const method = (0, react_redux_1.useSelector)(selectors_2.selectCurrentWithdrawalMethod);
    const accountId = (0, react_redux_1.useSelector)(selectors_1.selectAccountId);
    (0, react_1.useEffect)(() => {
        if (method && accountId) {
            dispatch(slice_1.balanceProviderActions.fetchPaymentAccounts());
        }
    }, [accountId, dispatch, method]);
    (0, react_1.useEffect)(() => {
        if (user && accountId) {
            dispatch(slice_1.balanceProviderActions.fetchPaymentMethodGroups());
        }
    }, [accountId, dispatch, user]);
};
exports.useBalanceProvider = useBalanceProvider;
//# sourceMappingURL=useBalanceProvider.js.map